// extracted by mini-css-extract-plugin
module.exports = {"container":"UGCHighlightSection_container__rhxBC","titleWrapper":"UGCHighlightSection_titleWrapper__xQ0RI","subtitle":"UGCHighlightSection_subtitle__a5XQD"};